module.exports = __webpack_public_path__ + "img/icontype10.37eacffd.png";